import { Inspect } from '../../../../components/Inspect'

export const InspectAIP = ({ goBackToPage, pages, values }) => {
  return Inspect({
    goBackToPage,
    pages,
    values,
    allegationDetails: [
      {
        heading: 'Allegation type',
        field_name: 'allegation',
        value: 'Select agent/import permit fraud',
        omitEdit: true
      }
    ]
  })
}
